import React, { Component } from "react"
import "./notificationsDropdown.scss"
import Notifications from "@material-ui/icons/Notifications"
import NotificationsSidebar from "../../../../screens/main/notifications/notificationsSidebar"
import ClickAwayListener from "@material-ui/core/ClickAwayListener/ClickAwayListener"
import styled from "@emotion/styled"
import * as routes from "../../../../library/constants/routes"
import { Link } from "react-router-dom"

const Container = styled.div`
  position: absolute;
  top: calc(100% + 9px);
  right: -15px;
  width: 400px;
  z-index: 250;
`

class NotificationsDropdown extends Component {
  state = {
    active: false,
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen(() => {
      this.setState({ active: false })
    })
  }

  componentWillUnmount() {
    this.unlisten()
  }

  toggleDropdown = () => {
    this.setState((prevState) => {
      return {
        active: !prevState.active,
      }
    })
  }

  handleClose = () => {
    this.setState({ active: false })
  }

  render() {
    const { active } = this.state
    const { notificationCounter } = this.props.notifications

    return (
      <div className="notifications-dropdown">
        <div className="d-none-xs">
          <button
            className="user-dropdown-menu__trigger"
            onClick={this.toggleDropdown}
          >
            <Notifications className="color-black-38" />
            {notificationCounter > 0 && (
              <div className="notifications-dropdown__counter">
                <span className="notifications-dropdown__text">
                  {notificationCounter}
                </span>
              </div>
            )}
          </button>
          {active && (
            <ClickAwayListener onClickAway={this.handleClose}>
              <Container>
                {active && <NotificationsSidebar {...this.props} />}
              </Container>
            </ClickAwayListener>
          )}
        </div>
        <div className="d-block-xs">
          <Link
            className="user-dropdown-menu__trigger"
            to={routes.NOTIFICATIONS}
          >
            <Notifications className="color-black-38" />
            {notificationCounter > 0 && (
              <div className="notifications-dropdown__counter">
                <span className="notifications-dropdown__text">
                  {notificationCounter}
                </span>
              </div>
            )}
          </Link>
        </div>
      </div>
    )
  }
}

export default NotificationsDropdown
